import React from 'react';
import { HERO_MOCKUP, VOLUME_PAGES } from '../data/assets';
type ProductVisualProps = {
  className?: string;
  eager?: boolean;
};

/**
 * Visual del producto. Si hay mockup principal, lo muestra; si no, arma un
 * abanico con 3 páginas reales del pack (portada, sesión, worksheet).
 */
export function ProductVisual({
  className = '',
  eager = false
}: ProductVisualProps) {
  if (HERO_MOCKUP) {
    return <img src={HERO_MOCKUP} alt="The No-Prep Chess Club Megapack: the six spiral-bound volumes on a chess club table" loading={eager ? 'eager' : 'lazy'} className={`w-full h-auto rounded-2xl ${className}`} data-id="element-217" data-mp="o12y7d26osc1" />;
  }
  const pages = [{
    src: VOLUME_PAGES.session,
    alt: 'Session plan page: The Welcome Game, with script, timing and split',
    cls: '-rotate-6 translate-y-4'
  }, {
    src: VOLUME_PAGES.cover,
    alt: 'Volume 1 cover: The Opening Weeks',
    cls: 'z-10 scale-110'
  }, {
    src: VOLUME_PAGES.worksheet,
    alt: 'Printable worksheet WS-04: The Queen’s Reach Maze',
    cls: 'rotate-6 translate-y-4'
  }];
  return <div className={`relative flex items-center justify-center gap-0 px-4 py-6 ${className}`} data-id="element-218" data-mp="1zeukkdx1gx0a">
      {pages.map((page, i) => <div key={page.src} className={`relative w-[34%] max-w-[210px] overflow-hidden rounded-xl border-2 border-ice bg-ice shadow-card ${i > 0 ? '-ml-[6%]' : ''} ${page.cls}`} data-id="element-219" data-mp="29bfpkz926844" data-mpi={i}>
          <img src={page.src} alt={page.alt} loading={eager ? 'eager' : 'lazy'} className="aspect-[9/16] w-full object-cover object-top" data-id="element-220" data-mp="2j07boqrfty74" />
        </div>)}
    </div>;
}